import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  dialog: {
    alignItems: "stretch",
    gap: `${theme.spacing.space24}px`,
  },

  header: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    gap: theme.spacing.space24,
  },

  colorText: {
    color: theme.colors.Primary,
  },

  summaryBox: {
    background: theme.colors.Background1,
    borderRadius: theme.radius.medium,
    padding: `${theme.spacing.space24}px ${theme.spacing.space16}px`,
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.space18,
  },

  summaryRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: `0px ${theme.spacing.space8}px`,
  },

  divider: {
    height: 1,
    background: theme.colors.Border1,
    width: "100%",
  },

  totalRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing.space12,
    borderRadius: theme.radius.small,
    background: "rgba(24, 119, 235, 0.15)",
    marginTop: theme.spacing.space12,
  },
}));
